export const SESSION_UPDATE_SESSION = 'SESSION_UPDATE_SESSION'

export const updateSession = (user) => ({
  type: SESSION_UPDATE_SESSION,
  payload: { user }
})
